import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var dialogTable = ref(false);
    var tableData = ref({});
    var userList = ref([]);
    var total = ref(0);
    var apiParams = ref({
      pageIndex: 1,
      pageSize: 10,
      organizeId: ""
    });

    var handleDialogClosed = function handleDialogClosed() {
      dialogTable.value = false;
    };

    var init = function init(item) {
      dialogTable.value = true;
      tableData.value = item;
      apiParams.value.organizeId = String(item.organizeId);
      getOrganizeUser();
    };

    var changPage = function changPage(val) {
      apiParams.value.pageIndex = val;
      getOrganizeUser();
    };

    var getOrganizeUser = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getOrganizeUserPage"](_objectSpread(_objectSpread({}, apiParams.value), {}, {
                  subOrgFlag: false
                }));

              case 2:
                res = _context.sent;
                total.value = res.total;
                userList.value = res.data;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getOrganizeUser() {
        return _ref2.apply(this, arguments);
      };
    }();

    expose({
      init: init
    });
    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_table = _resolveComponent("el-table");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogTable),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(dialogTable) ? dialogTable.value = $event : dialogTable = $event;
        }),
        title: "详情",
        width: "700px",
        onClosed: handleDialogClosed
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table, {
            data: _unref(userList),
            style: {
              "width": "700px"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                prop: "username",
                label: "名字",
                width: "180"
              }), _createVNode(_component_el_table_column, {
                prop: "name",
                label: "所属组织",
                width: "180"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref(tableData).orgName), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "politicalIdentity",
                label: "政治面貌"
              }, {
                default: _withCtx(function (scope) {
                  return [_createTextVNode(_toDisplayString(scope.row.politicalIdentity == 1 ? "党员" : "群众"), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data"]), _createVNode(Pagination, {
            pagesize: 10,
            "total-num": _unref(total),
            onChangPage: changPage
          }, null, 8, ["total-num"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});